const choices = {
    budgeted: 'Budgétisés par le client',
    financed: 'Financés par le client (différé total)',
    ignored: 'Non pris en compte dans la simulation',
    takenByPromoter: 'Pris en charge par le promoteur',
};

export default choices;
